import { render } from "./ManagementUsers.vue?vue&type=template&id=05800f90&scoped=true"
import script from "./ManagementUsers.vue?vue&type=script&lang=js"
export * from "./ManagementUsers.vue?vue&type=script&lang=js"

import "./../../../assets/styles/admin/users/usersMain.scss?vue&type=style&index=0&id=05800f90&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05800f90"]])

export default __exports__